// @ts-check
import React from 'react';
import InputContainer from './InputContainer';
import Link from './Link';

import './LoginButton.scss';

const BOB_FORM_FormId = 'ebc-form';
const BOB_FORM_Username = 'ebc-username';
const BOB_FORM_Password = 'ebc-password';

/**
 * @typedef LoginFormBusinessBankingProps
 * @property {import('~/templates/hero/PageHeroLoginForm').PageHeroLoginFormOptionsWith$} options
 */
/** @type {import('~/types/React').ReactFC<LoginFormBusinessBankingProps>} */
const LoginFormBusinessBanking = ({ options }) => (
	<React.Fragment>
		<form className="BOLoginForm" method="POST" id={BOB_FORM_FormId}>
			<InputContainer icon="business">
				<label htmlFor="ebc-username" tabIndex={-1}>
					{options.username_placeholder}
				</label>
				<input
					className="BOLoginUsernameInput"
					type="text"
					name="ebc-username"
					id="ebc-username"
					autoComplete="off"
					{...options.$?.username_placeholder}
				/>
			</InputContainer>
			<InputContainer icon="lock">
				<label htmlFor={BOB_FORM_Password} tabIndex={-1}>
					{options.password_placeholder}
				</label>
				<input
					className="BOLoginPasswordInput"
					type="password"
					name={BOB_FORM_Password}
					id={BOB_FORM_Password}
					autoComplete="off"
					{...options.$?.password_placeholder}
				/>
			</InputContainer>
			<input
				className="BOLoginSubmitButton login-button btn"
				type="submit"
				value={options.button_text ?? 'Login'}
				id="ebcsubmit"
				{...options.$?.button_text}
			/>
		</form>
		<div style={{ textAlign: 'center', paddingTop: '0.5rem', paddingBottom: '1rem' }}>
			{!!options.links?.[0] && (
				<Link to={options.links[0].link_url} {...options.links[0].$?.link_url}>
					{options.links[0].link_text}
				</Link>
			)}
			{!!options.links?.[1] && (
				<>
					<span> | </span>
					<Link to={options.links[1].link_url} {...options.links[1].$?.link_url}>
						{options.links[1].link_text}
					</Link>
				</>
			)}
		</div>
	</React.Fragment>
);

/** @type {import('~/types/React').ReactFC<import('gatsby').HeadProps>} */
const BoBHead = ({ location }) => {
	const bob_fqdn = 'web4.secureinternetbank.com';
	const profile_id = '164';

	// We only want to inject this business form info on specific pages.
	if (!['/login/business/', '/business/'].includes(location?.pathname)) {
		return null;
	}

	return (
		<React.Fragment>
			<script type="text/javascript" src={`https://${bob_fqdn}/EBC_EBC1151/js/Remoteloginload`} />
			<script type="text/javascript" defer={true}>
				{`
					// Since Helmet is adding the above script to the document, it is automatically async, so
					// this script will execute immediately. We have to account for the very real possibility
					// that the EBC object will not yet be ready on the window, and recursively recall until it is.
					// This can be tested by blocking the network request for the above script and watching the console.
					// Sticking to ES5 here for IE compatibility.
					(function initForm() {
						var wait_time_in_ms = 500;

						// Short circuit if we know the init will fail due to no form or SDK.
						if(!window.EBC || !document.getElementById("${BOB_FORM_FormId}")) {
							console.warn("EBC not ready. Waiting " + wait_time_in_ms + " ms.");
							
							if (['/login/business/', '/business/'].includes(location?.pathname))
								setTimeout(initForm, wait_time_in_ms);
							
							return;
						}
						
						var args = {
							applicationPath: "https://${bob_fqdn}/EBC_EBC1151",
							formId: "${BOB_FORM_FormId}",
							passwordId: "${BOB_FORM_Password}",
							routingTransit: "082907273",
							profileNumber: ${profile_id},
							usernameId: "${BOB_FORM_Username}"
						}
						new EBC.RemoteLogin(args);
						console.debug("EBC loaded.");
					})();`}
			</script>
		</React.Fragment>
	);
};

export default LoginFormBusinessBanking;
export const Head = BoBHead;
